import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryequipmentAdminComponent } from './supplementaryequipment-admin/supplementaryequipment-admin.component';
import { AppPropertiesService, AppPropertyComponentsModule, CommonLayoutModule, CommonUIModule } from '@sdbn/common';



@NgModule({
  declarations: [
    SupplementaryequipmentAdminComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    AppPropertyComponentsModule,
    CommonUIModule
  ]
})
export class SupplementaryequipmentAdminModule {

  constructor(
    private appPropertiesService: AppPropertiesService
  ) {

    appPropertiesService.registerAppPropertiesAdminComponent('tmc-yard.supplementaryequipment.ui.supplementaryequipment-properties-admin.tab-title', SupplementaryequipmentAdminComponent);


  }
 }
